export default __webpack_public_path__ + "static/media/mb_login_image_3_min.c7006eba.jpg";